import RecipientDetails from './RecipientDetails.component';

export default RecipientDetails;
